import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useCuentaYPermisos } from '../lib/permisosDelEquipo';
import { BotonesParaEscribirleAlDueno, textoPedileAlDueno } from './PedileAlDueno';

/**
 * Pantalla que ve un MIEMBRO cuando llega a cambiar el plan o la facturación (spec
 * 2026-09-11-invitaciones-equipo §4.3; ADR-2026-10-19-permisos-por-miembro-del-equipo).
 * Un guard en las pantallas de plata (Checkout, Paywall, Facturación) cubre todos los CTAs
 * de "mejorar plan" de la app sin tocar cada uno. Dice a quién pedírselo, con su mail.
 */
export const SoloElDueno = () => {
  const navigate = useNavigate();
  const { dueno } = useCuentaYPermisos();
  return (
    <div className="min-h-screen bg-[#EFF0F5] flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl border border-black/[0.06] p-8 text-center">
        <Lock className="w-10 h-10 text-brand-primary mx-auto mb-4" />
        <h1 className="text-[20px] font-semibold text-brand-black">
          Solo el administrador de la empresa{dueno ? ` (${dueno.nombre})` : ''} puede cambiar el plan y la facturación
        </h1>
        <p className="text-[15px] text-neutral-500 mt-2 mb-6">
          {textoPedileAlDueno(dueno, 'si necesitás más créditos o un cambio en el plan')}
        </p>
        <BotonesParaEscribirleAlDueno dueno={dueno} />
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="mt-2.5 w-full py-2.5 px-5 rounded-lg border border-neutral-200 bg-white text-brand-black/90 text-[15px] font-medium hover:bg-neutral-50"
        >
          Volver
        </button>
      </div>
    </div>
  );
};

export default SoloElDueno;
